<template>
  <div>
    <div
      class="place-wrapper reserved"
      v-if="isReservedPlace(place)"
      :style="{
        left: Math.round(place.X * scaleValue) + 'px',
        top: Math.round(place.Y * scaleValue) + 'px',
        background: '#59636b',
        width: 20 * scaleValue + 'px',
        height: 20 * scaleValue + 'px',
        fontSize: 16 * scaleValue + 'px',
      }"
    >
      <div class="place">
        {{ place.Number }}
      </div>
    </div>
    <div
      class="place-wrapper"
      v-else-if="session.Prices.length"
      :style="{
        left: Math.round(place.X * scaleValue) + 'px',
        top: Math.round(place.Y * scaleValue) + 'px',
        background: getPlaceColor,
        width: 20 * scaleValue + 'px',
        height: 20 * scaleValue + 'px',
        fontSize: 20 * scaleValue + 'px',
      }"
      @click="changePlaceInCart"
      :class="[{ added: addedClass }]"
    >
      <div class="place">
        {{ place.Number }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { types } from '@/types';
import { find, indexOf, filter } from 'lodash';

export default {
  name: 'Place',

  props: {
    place: {},
    scaleValue: {},
  },

  computed: {
    ...mapState([
      'session',
      'cart',
      'errors',
      'places',
      'setting',
      'movie',
      'theatre',
    ]),
    getPlaceColor() {
      let color = '';
      if (this.session.Prices.length) {
        this.session.Prices.forEach((item) => {
          if (item.Id === this.place.TypeId) {
            color = item.Color.slice(0, -2);
          }
        });
      }

      return color;
    },
    addedClass() {
      let placeInCart = find(this.cart.tickets, ['id', this.place.Id]);

      if (typeof placeInCart !== 'object') {
        return false;
      } else {
        return true;
      }
    },
  },

  methods: {
    isReservedPlace(place) {
      const isPlaceInCart = this.cart.tickets.find(
        (item) => item.id === place.Id,
      );
      const isPlaceInRemovedList = this.cart.deletedTickets.find(
        (item) => item.id === place.Id,
      );

      return (
        (place.Status !== 'Free' || place.Status === 'Reserved') &&
        !isPlaceInCart &&
        !isPlaceInRemovedList
      );
    },
    changePlaceInCart() {
      let placeInCart = find(this.cart.tickets, ['id', this.place.Id]);
      let index = indexOf(this.cart.tickets, placeInCart);

      let placesForCart = [];

      if (this.place.FragmentId) {
        let placeGroup = filter(this.places, (item) => {
          return item.FragmentId === this.place.FragmentId;
        });

        placeGroup.forEach((place) => {
          let placePrice = find(this.session.Prices, ['Id', place.TypeId]);

          placesForCart.push({
            price: placePrice.Sum,
            variants: [
              ...placePrice.Discounts.map(({ Name, Sum, TicketId }) => ({
                Name,
                Sum,
                TicketId,
                typeId: TicketId,
              })),
              {
                typeId: placePrice.TicketId,
                Name: placePrice.TicketName,
                Sum: placePrice.Sum,
              },
            ],
            name: placePrice.Name,
            typeId: placePrice.TicketId,
            id: place.Id,
            row: place.Row,
            number: place.Number,
          });
        });
      } else {
        let placePrice = find(this.session.Prices, ['Id', this.place.TypeId]);

        placesForCart.push({
          price: placePrice.Sum,
          variants: [
            ...placePrice.Discounts.map(({ Name, Sum, TicketId }) => ({
              Name,
              Sum,
              TicketId,
              typeId: TicketId,
            })),
            {
              typeId: placePrice.TicketId,
              Name: placePrice.TicketName,
              Sum: placePrice.Sum,
            },
          ],
          name: placePrice.Name,
          typeId: placePrice.TicketId,
          id: this.place.Id,
          row: this.place.Row,
          number: this.place.Number,
        });
      }

      if (index !== -1) {
        this.unreservePlace(placesForCart);
      } else {
        this.reservePlace(placesForCart);
      }
    },

    unreservePlace(placesForCart) {
      placesForCart.forEach((place) => {
        let placeInCart = find(this.cart.tickets, ['id', place.id]);

        let index = indexOf(this.cart.tickets, placeInCart);
        this.$store.dispatch('logTicket', {
          place,
          type: 'RemoveItem',
          index,
        });

        console.log(place, 'placeRemove');

        // // eslint-disable-next-line no-undef
        // dataLayer.push({ ecommerce: null });  // очистка уровня данных.
        // // eslint-disable-next-line no-undef
        // dataLayer.push({
        //   'ecommerce': {
        //     'currencyCode': 'RUB',
        //     'add': {
        //       'products':   [
        //           {
        //             'id': place.id,              // где film_id это id фильма или товара.
        //             'name': place.name,          // где film_name это название фильма или товара.
        //             'price': place.price,      // где ticket_price это цена за билет или товар.
        //             'category': this.movie.Genre,  // где category_name это название категории фильма.
        //             'brand': this.theatre.Name,           // где cinema это название кинотеатра.
        //             'variant': this.session.DateTime,      // где date-time это дата и время фильма.
        //             'quantity': '1'
        //           }
        //       ]
        //     }
        //   },
        //   'event': 'gtm-ee-event',
        //   'gtm-ee-event-category': 'Enhanced Ecommerce',
        //   'gtm-ee-event-action': 'Adding a Product to a Shopping Cart',
        //   'gtm-ee-event-non-interaction': 'False'
        // });
      });
    },

    reservePlace(placesForCart) {
      let currentCartTicketCount = this.cart.tickets.length;
      let maxSeats = this.theatre.MaxSeats ? this.theatre.MaxSeats : 5;
      if (currentCartTicketCount + placesForCart.length > maxSeats) {
        this.$store.commit(
          types.ADD_ERROR,
          `Максимальное возможное количество мест для выбора не должно превышать ${maxSeats}шт.`,
        );
        this.$store.commit(types.CLEAR_ERRORS, 3000);

        return;
      }

      placesForCart.forEach((place) => {
        this.$store.dispatch('logTicket', {
          place,
          type: 'AddItem',
        });

        // // eslint-disable-next-line no-undef
        // dataLayer.push({ ecommerce: null });  // очистка уровня данных.
        // // eslint-disable-next-line no-undef
        // dataLayer.push({
        //   'ecommerce': {
        //     'currencyCode': 'RUB',
        //     'add': {
        //       'products':   [
        //           {
        //             'id': place.id,              // где film_id это id фильма или товара.
        //             'name': place.name,          // где film_name это название фильма или товара.
        //             'price': place.price,      // где ticket_price это цена за билет или товар.
        //             'category': this.movie.Genre,  // где category_name это название категории фильма.
        //             'brand': this.theatre.Name,           // где cinema это название кинотеатра.
        //             'variant': this.session.DateTime,      // где date-time это дата и время фильма.
        //             'quantity': '1'
        //           }
        //       ]
        //     }
        //   },
        //   'event': 'gtm-ee-event',
        //   'gtm-ee-event-category': 'Enhanced Ecommerce',
        //   'gtm-ee-event-action': 'Removing a Product',
        //   'gtm-ee-event-non-interaction': 'False'
        // });
      });
    },
  },
};
</script>

<style src="./Place.scss" lang="scss"></style>
